




















































































































































import { Vue, Component } from 'vue-property-decorator';
import TreeContainer from '@/components/tree/tree.vue';
import PagingUnit from '@/components/paging/paging.vue';
import login from '@/views/login/login.vue';

@Component({
  components: { TreeContainer, PagingUnit },
})
export default class RoleAssignmentUser extends Vue {
  openFlag = true; // 控制左侧导航栏是否显示
  moreFlag = false; // 控制显示更多搜索框
  addUserVisible = false; // 是否显示弹窗的标志
  // 弹窗里的表单的数据
  formDatas: any = [
    {
      otherOrgan: '附属机构',
      otherStation: '附属岗位',
    },
    {
      otherOrgan: '附属机构1',
      otherStation: '附属岗位1',
    },
  ];

  // 分页的数据
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'label',
  };
  checkNode: any = {}; // 选中的节点数据
  // 树形图的数据
  treeData: Array<any> = [
    {
      label: '一级 1',
      id: '1',
      children: [
        {
          label: '二级 1-1',
          id: '1-1',
          children: [
            {
              label: '三级 1-1-1',
              id: '1-1-1',
            },
          ],
        },
      ],
    },
  ];
  total = 1000; // 数据总共多少条
  openTreeFlag = false; // 树是否打开
  // 搜索栏的数据对象
  searchFormData: object = {
    userAccount: '',
    userPsd: '',
    systemRole: '',
    userState: '',
    email: '', // 邮箱
    station: '', // 岗位
    companyPhone: '', //公司电话
    page: 1, // 访问哪一页数据
    role: '', // 角色
  };
  // 表格的表头数据
  tableHeadData: any[] = [
    { prop: 'userAccount', label: '登录账号' },
    { prop: 'nickName', label: '用户昵称' },
    { prop: 'email', label: '电子邮箱' },
    { prop: 'systemRole', label: '手机号码' },
    { prop: 'companyPhone', label: '办公电话' },
    { prop: 'updateTime', label: '更新时间' },
    { prop: 'state', label: '状态' },
    { prop: '', label: '操作' },
  ];
  // 表格的数据对象
  tableData: Array<any> = [
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:55', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:55', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:55', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:55', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:90', // 更新时间
      state: 2, // 状态
    },
    {
      userAccount: 'user',
      nickName: '蓝菲菲', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-14 14:32', // 更新时间
      state: 3, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-15 14:32', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: '123',
      nickName: '刘菲菲', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-16 19:32', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 1, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 3, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 3, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 3, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 2, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 2, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 2, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 2, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 2, // 状态
    },
    {
      userAccount: 'admin1',
      nickName: '刘龙', // 用户昵称
      email: '1405664957@qq.com', // 电子邮箱
      systemRole: '15558476933', // 手机号码
      companyPhone: '053188888888', // 办公电话
      updateTime: '2021-05-13 14:32', // 更新时间
      state: 2, // 状态
    },
  ];
  multipleSelection: any = [];

  /**
   * @todo 后期需要优化的部分
   * @desc 查询 表单
   * @param1 暂无
   * @returns 暂无
   */
  searchBtn(): void {
    alert('查询');
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 重置搜索的表单
   * @param1 暂无
   * @returns 暂无
   */
  resetSearch(): void {
    (this.$refs.formRef as any).resetFields();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  点击 复选框 则 输出这一行的值
   * @param1 暂无
   * @returns 暂无
   */
  handleSelectionChange(val: any): void {
    this.multipleSelection = val;
    console.log(val);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  删除用户
   * @param1 暂无
   * @returns 暂无
   */
  deleteUser(): void {
    this.$confirm('确认要取消该用户角色吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 状态的计算属性，如果状态是 1 则是正常 ,2 停用, 3 冻结
   * @param1 传入用户的 state 状态值
   * @returns 计算属性返回一个函数可以来传参，函数进行判断。
   */
  get setUserState(): object {
    return (state: number): string => {
      if (state == 1) {
        return '正常';
      } else if (state == 2) {
        return '停用';
      } else {
        return '冻结';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 计算属性：判断用户状态从而给出状态按钮背景颜色。
   * @param1 传入用户的 state 状态值
   * @returns 返回一个函数，用于传递参数和判断状态按钮背景颜色。
   */
  get setStateColor(): object {
    return (state: number): string => {
      if (state == 1) {
        return 'tag-green';
      } else if (state == 2) {
        return 'tag-red';
      } else {
        return 'tag-orange';
      }
    };
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 分页换页事件处理。
   * @param1 要跳转到第几页
   * @returns 暂无
   */
  handleCurrentChange(val: number): void {
    (this.searchFormData as any).page = val;
    console.log(val, '利用这个 val 来访问新的数据');
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击图标进入机构管理组件
   * @param1 暂无
   * @returns 暂无
   */
  enterOrganManage(): void {
    window.alert('进入机构管理');
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 切换数据树状态，全部打开或者全部关闭。
   * @param1 暂无
   * @returns 暂无
   */
  changeTreeState(): void {
    this.openTreeFlag = !this.openTreeFlag;
    (this.$refs.treeRef as any).store._getAllNodes().forEach((val: any, i: number) => {
      if (this.openTreeFlag) {
        val.expanded = true;
      } else {
        val.expanded = false;
      }
    });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮 弹出添加用户的弹窗
   * @param1 暂无
   * @returns 暂无
   */
  addUser(): void {
    this.addUserVisible = true;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮 隐藏添加用户的弹窗
   * @param1 暂无
   * @returns 暂无
   */
  closeUser(): void {
    this.addUserVisible = false;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮 弹出是否批量取消框
   * @param1 暂无
   * @returns 暂无
   */
  batchCancelled(): void {
    if (this.multipleSelection.length === 0) {
      this.$notify.info({
        title: '',
        message: '请在列表选中要取消角色的用户',
        position: 'bottom-right',
      });
    } else {
      this.$confirm('确认要取消列表中权重的用户角色权限吗？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'batchCancelled-msg',
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮返回角色管理界面
   * @param1 暂无
   * @returns 暂无
   */
  backRole(): void {
    this.$emit('close');
  }
}
